import { createContext, useMemo, useState } from "react";

const STORAGE_KEY = "submission_draft_v1";

const getDefaultDraft = () => ({
  name: "",
  email: "",
  authors: [],
  correspondingAuthorId: "",
  correspondenceName: "",
  correspondenceEmail: "",
  countryCode: "+91",
  phone: "",
  country: "India",
  address: "",
  msTitle: "",
  msId: "",
  journalName: "",
  journalNameManual: "",
  manuscriptType: "",
  conflictOfInterest: "",
  fundingInformation: "",
  declaration: "",
  additionalNotes: "",
  signatureMode: "",
  signatureDataUrl: "",
  termsAccepted: false
});

const readStoredDraft = () => {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    if (!value) {
      return getDefaultDraft();
    }
    const parsed = JSON.parse(value);
    return { ...getDefaultDraft(), ...(parsed || {}) };
  } catch {
    return getDefaultDraft();
  }
};

export const SubmissionDraftContext = createContext({
  draft: getDefaultDraft(),
  updateDraft: () => {},
  resetDraft: () => {}
});

export default function SubmissionDraftProvider({ children }) {
  const [draft, setDraft] = useState(readStoredDraft);

  const updateDraft = (nextValues) => {
    setDraft((previous) => {
      const merged = { ...previous, ...nextValues };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
      return merged;
    });
  };

  const resetDraft = () => {
    const emptyDraft = getDefaultDraft();
    setDraft(emptyDraft);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(emptyDraft));
  };

  const contextValue = useMemo(
    () => ({
      draft,
      updateDraft,
      resetDraft
    }),
    [draft]
  );

  return (
    <SubmissionDraftContext.Provider value={contextValue}>
      {children}
    </SubmissionDraftContext.Provider>
  );
}
